export default {"src":"/_next/static/media/websitex5.6513e654.svg","height":73,"width":442,"blurWidth":0,"blurHeight":0};